//@flow
import * as Immutable from 'immutable';

import { GeocodeEditLocation } from 'common/models/flow/GeocodeEditLocation';
import type { GeocodeEditLocationModelType } from 'common/models/flow/GeocodeEditLocation';

import { Geometry } from './Geometry';
import { StructuredAddress } from './StructuredAddress';
import { ContactPoint } from './ContactPoint';

import { GeocodeVerifiedGeometry } from './GeocodeVerifiedGeometry';

class InternalGeocodeEditLocation extends GeocodeEditLocation {
    static fromJS(
        json: GeocodeEditLocationModelType
    ): InternalGeocodeEditLocation {
        const state: Object = Object.assign({}, json);
        state.address = state.address
            ? StructuredAddress.fromJS(state.address)
            : state.address;
        state.geometry = state.geometry
            ? Geometry.fromJS(state.geometry)
            : state.geometry;
        state.originalGeometry = state.originalGeometry
            ? Geometry.fromJS(state.originalGeometry)
            : state.originalGeometry;
        state.geocodeVerifiedGeometry = state.geocodeVerifiedGeometry
            ? GeocodeVerifiedGeometry.fromJS(state.geocodeVerifiedGeometry)
            : state.geocodeVerifiedGeometry;
        state.archive = state.archive
            ? Immutable.List(state.archive).map(item => Geometry.fromJS(item))
            : state.archive;
        state.contactPoint = state.contactPoint
            ? ContactPoint.fromJS(state.contactPoint)
            : state.contactPoint;
        state.metadata = state.metadata
            ? Immutable.List(state.metadata)
            : state.metadata;
        return new this(Immutable.Map(state));
    }

    isEditInProgress(editingEntityIds: Array<string>): ?boolean {
        return this.isIncluded(editingEntityIds);
    }
    isVerifyInProgress(verifyingEntityIds: Array<string>): ?boolean {
        return this.isIncluded(verifyingEntityIds);
    }
    isIncluded(idsList: Array<string>): ?boolean {
        return idsList && idsList.includes(this.id);
    }

    getIsApplySystemGeocodeVisible() {
        if (!this.geocodeVerifiedGeometry) {
            return false;
        }
        const hasGeocodedLatLng = this.geocodeVerifiedGeometry.hasGeocodedLatLng();
        const isDifferentLatLng = this.geocodeVerifiedGeometry.isDifferentLatLng(
            this.geometry
        );
        return hasGeocodedLatLng && isDifferentLatLng;
    }

    get address(): ?StructuredAddress {
        return this._state.get('address');
    }

    get geometry(): ?Geometry {
        return this._state.get('geometry');
    }

    get originalGeometry(): ?Geometry {
        return this._state.get('originalGeometry');
    }

    get contactPoint(): ?ContactPoint {
        return this._state.get('contactPoint');
    }

    get archive(): ?Immutable.List<Geometry> {
        return this._state.get('archive');
    }

    get geocodeVerifiedGeometry(): ?GeocodeVerifiedGeometry {
        return this._state.get('geocodeVerifiedGeometry');
    }
}

export { InternalGeocodeEditLocation as GeocodeEditLocation };
